import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatAddress, { FormatAddressString } from "go-core/components/Formatters/FormatAddress";
import { ReactComponent as HomeSVG } from "go-core/images/svg/home.svg";
import { ReactComponent as TelephoneSVG } from "go-core/images/svg/phone.svg";
import { ReactComponent as FacebookSVG } from "../../../../../../images/svg/organization/facebook.svg";
import { ReactComponent as InstagramSVG } from "../../../../../../images/svg/organization/instagram.svg";
import { ReactComponent as LinkedinSVG } from "../../../../../../images/svg/organization/linkedin.svg";
import { ReactComponent as WebsiteSVG } from "../../../../../../images/svg/organization/website.svg";
import { OrganizationPlaceApi } from "../../../../../../services/Api/types";

interface Props {
	place: OrganizationPlaceApi;
	company_phone_number: string;
}

const OrganizationContactInfoCard = ({ place, company_phone_number }: Props) => {
	const { t } = useTranslation("admin");

	if (!place && !company_phone_number) {
		return null;
	}

	return FormatAddressString(place) ||
		place?.linkedin ||
		place?.website ||
		place?.facebook ||
		place?.instagram ||
		company_phone_number ? (
		<Card>
			<Card.Body>
				<h5>{t("common.word.contact_info")}</h5>
				{FormatAddressString(place) && (
					<div className="card-body-item" title={FormatAddressString(place)}>
						<HomeSVG />
						<span>
							<FormatAddress address={place} />
						</span>
					</div>
				)}
				{company_phone_number && (
					<div className="card-body-item" title={`+${company_phone_number}`}>
						<TelephoneSVG />
						<span>+{company_phone_number}</span>
					</div>
				)}
				{place?.website && (
					<div className="card-body-item" title={place.website}>
						<WebsiteSVG />
						<a target="_blank" rel="noreferrer" className="text-truncate" href={place.website}>
							{place.website}
						</a>
					</div>
				)}
				{place?.facebook && (
					<div className="card-body-item" title={place.facebook}>
						<FacebookSVG />
						<a target="_blank" rel="noreferrer" className="text-truncate" href={`//${place.facebook}`}>
							{place.facebook}
						</a>
					</div>
				)}
				{place?.instagram && (
					<div className="card-body-item" title={place.instagram}>
						<InstagramSVG />
						<a target="_blank" rel="noreferrer" className="text-truncate" href={`//${place.instagram}`}>
							{place.instagram}
						</a>
					</div>
				)}
				{place?.linkedin && (
					<div className="card-body-item">
						<LinkedinSVG />
						<a target="_blank" rel="noreferrer" className="text-truncate" href={`//${place.linkedin}`}>
							{place.linkedin}
						</a>
					</div>
				)}
			</Card.Body>
		</Card>
	) : (
		<></>
	);
};

export default OrganizationContactInfoCard;
